'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AttentiveOptin = exports.HandleAttentiveCookie = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _poll = require('../core/poll');

var _poll2 = _interopRequireDefault(_poll);

require('unfetch/polyfill');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HandleAttentiveCookie = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
    var selectors, checkboxMarkup, handleAttentiveCookie;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // Selectors
            selectors = {
              phoneInput: '[data-address-field="phone"]',
              attentiveCheck: '#attentive_opt_in',
              attentiveWrapper: '.attentive__opt-in-wrapper'
            };

            // Markup

            checkboxMarkup = '\n  <div class="checkbox-wrapper attentive__opt-in-wrapper">\n    <div class="checkbox__input">\n      <input class="input-checkbox" type="checkbox" name="checkout[attentive_opt_in]" id="attentive_opt_in">\n    </div>\n    <label class="checkbox__label attentive__opt-in-label" for="attentive_opt_in">\n      By checking this box, you agree to receive recurring automated promotional and personalized marketing text messages (e.g. cart reminders) from Amala at the cell number used when signing up. Consent is not a condition of any purchase. Reply HELP for help and STOP to cancel. Msg frequency varies. Msg & data rates may apply. <a href="http://attn.tv/amala/terms.html">View Terms</a> & <a href="/pages/privacy-policy">Privacy</a>.\n    </label>\n  </div>\n  ';

            handleAttentiveCookie = function handleAttentiveCookie(number) {
              if (!number) {
                _jsCookie2.default.remove('attentive_number');
              } else {
                // Store cookie as base64 just for good measure
                _jsCookie2.default.set('attentive_number', btoa('+1' + number), { secure: true, expires: 1 / 48 });
              }
            };

            // Remove the cookie if user is on info step in event their info hasn't populated yet.


            if (window.Shopify.Checkout.step == 'contact_information') {
              handleAttentiveCookie();
            }

            (0, _poll2.default)(function () {
              return document.querySelector(selectors.phoneInput);
            }, 6000, 250).then(function (el) {
              // Remove any pre-exising Attentive markup
              var existingMarkup = document.querySelectorAll(selectors.attentiveWrapper);
              if (existingMarkup) {
                existingMarkup.forEach(function (el) {
                  return el.remove();
                });
              }

              // Insert new Attentive markup and carry on
              el.insertAdjacentHTML('beforeend', checkboxMarkup);
              var attentiveCheckbox = document.querySelector(selectors.attentiveCheck);
              var phoneNumber = window.Shopify.Checkout.customer_phone || null;

              attentiveCheckbox.addEventListener('change', function (event) {
                if (event.target.checked && phoneNumber) {
                  handleAttentiveCookie(phoneNumber);
                } else {
                  console.log('Required info not present for Attentive Subscription.');
                  handleAttentiveCookie();
                }
              });
            }).catch(function () {
              console.log('Something went wrong waiting for the phone input...');
              // Remove the cookie because user could not consent to marketing
              handleAttentiveCookie();
            });

          case 5:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function HandleAttentiveCookie() {
    return _ref.apply(this, arguments);
  };
}();

var AttentiveOptin = function AttentiveOptin() {
  var submitAttentivePhone = function submitAttentivePhone(number, id) {
    if (!number || number.length < 10 || !id) return;
    console.log('Attentive is preparing to submit...');

    var userData = {
      phone: '' + number,
      visitorId: '' + id
    };

    fetch('https://api.attentivemobile.com/1/add-subscribers', {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        authorization: 'Bearer tNSWHrBG4wCRZ7Tv0TniVKy_GVQ_UDatxeylSxINYRg'
      },
      body: JSON.stringify(userData)
    }).then(function (response) {
      console.log('Attentive Response: ', response);
    }).catch(function (err) {
      console.log('Attentive Failed...', err);
    });
  };

  var phoneNumber = atob(_jsCookie2.default.get('attentive_number')) || null;
  var attentiveId = _jsCookie2.default.get('__attentive_id') || null;

  if (phoneNumber && attentiveId) {
    submitAttentivePhone(phoneNumber, attentiveId);
  } else {
    console.log('Not enough info to subscribe to Attentive.');
  }
};

exports.HandleAttentiveCookie = HandleAttentiveCookie;
exports.AttentiveOptin = AttentiveOptin;